import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FilterBuilder } from "@/components/crm/ViewControls";

export default function CustomMetricDialog({ metrics, onClose, onSaved }) {
  const [cfg, setCfg] = useState(null);
  const [users, setUsers] = useState([]);
  const [m, setM] = useState({ label: "", filters: [], match: "all", in_range: false });
  useEffect(() => {
    api.get("/crm/config").then((r) => setCfg(r.data));
    api.get("/crm/users").then((r) => setUsers(r.data.rows));
  }, []);
  const save = async () => {
    if (!m.label.trim()) { toast.error("Name the metric"); return; }
    const id = Math.random().toString(36).slice(2, 8);
    try {
      await api.put("/crm/config", { custom_metrics: [...metrics, { ...m, id, label: m.label.trim() }] });
      toast.success("Metric added"); onSaved(`cm_${id}`);
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't save metric"); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[var(--panel)] border-[var(--border-strong)] max-w-md" data-testid="custom-metric-dialog">
        <DialogHeader><DialogTitle className="text-base font-medium">New metric</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <input className="w-full px-2.5 py-1.5 rounded border text-sm" placeholder="Name, e.g. Proposals out" value={m.label} onChange={(e) => setM({ ...m, label: e.target.value })} data-testid="custom-metric-label" autoFocus />
          <div className="flex items-center gap-2">
            <span className="text-[var(--text-dim)]">Counts leads where</span>
            {cfg && <FilterBuilder filters={m.filters} onChange={(filters) => setM({ ...m, filters })} match={m.match} onMatch={(match) => setM({ ...m, match })} fields={cfg.fields} stages={cfg.stages} users={users} />}
          </div>
          <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={m.in_range} onChange={(e) => setM({ ...m, in_range: e.target.checked })} data-testid="custom-metric-in-range" />Only leads created in the selected date range</label>
          <button className="btn btn-primary w-full justify-center" onClick={save} data-testid="custom-metric-save">Add metric</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
